import React from 'react';
import { Modal } from 'react-bootstrap';
import './style.scss';

const HelpPdfModal = ({ show, onHide, pdfUrl, title }) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered className="help-pdf-modal">
      <Modal.Header closeButton>
        <Modal.Title>{title || 'Manual de Ayuda'}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: '80vh', padding: 0 }}>
        {pdfUrl && <iframe src={pdfUrl} style={{ width: '100%', height: '100%', border: 'none' }} title="Manual PDF" />}
      </Modal.Body>
    </Modal>
  );
};

export default HelpPdfModal;
